
<script setup lang="ts">
const meta = {"title":"Vuetify — A Vue Component Framework","description":"Vuetify is a no-design-skills-required Open Source UI component framework for Vue with everything you need to build beautiful, content-rich web apps.","keywords":"vue, vue components, vue ui components, material design components, vuetify, component framework, component library"}
 const assets = undefined
 const backmatter = undefined
 const features = undefined
 const fluid = undefined
 const related = undefined
 const toc = []
  defineExpose({ frontmatter: {"meta":{"title":"Vuetify — A Vue Component Framework","description":"Vuetify is a no-design-skills-required Open Source UI component framework for Vue with everything you need to build beautiful, content-rich web apps.","keywords":"vue, vue components, vue ui components, material design components, vuetify, component framework, component library"},"toc":[]}, excerpt: undefined })
</script>
<script lang="ts">
/** frontmatter meta-data for MD page **/
export interface Frontmatter {
  title?: string
  description?: string
  subject?: string
  category?: string
  name?: string
  excerpt?: string
  image?: string
  layout?: string
  requiredAuth?: boolean
  meta?: Record<string, any>[]
  [key: string]: unknown
}
export const frontmatter: Frontmatter = {"meta":{"title":"Vuetify — A Vue Component Framework","description":"Vuetify is a no-design-skills-required Open Source UI component framework for Vue with everything you need to build beautiful, content-rich web apps.","keywords":"vue, vue components, vue ui components, material design components, vuetify, component framework, component library"},"toc":[]}
export const excerpt: string | undefined = ""

</script>
<template>
<div><home-entry></home-entry>
<home-special-sponsor></home-special-sponsor>
<home-gallery-components></home-gallery-components>
<v-divider></v-divider>
<home-sponsors></home-sponsors>
<v-divider></v-divider>
<home-ecosystem></home-ecosystem>
<v-divider></v-divider>
<home-vuetify-one></home-vuetify-one>
<v-divider></v-divider>
<home-tooling></home-tooling>
<v-divider></v-divider>
<home-snips></home-snips>
<v-divider color="primary"></v-divider>
<home-support></home-support>
<v-divider></v-divider>
<home-discord></home-discord>
<v-divider></v-divider>
<home-blogs></home-blogs>
</div>
</template>
